import { useState } from 'react';
import { ReactComponent as PdfIcon } from '@/assets/img/v2/pdf-icon.svg';
import { ReactComponent as DeleteIcon } from '@/assets/img/v2/delete.red-icon.svg';

import './PetInsuranceForm.scss';

type InsuranceCardProps = {
  data: any;
  onDelete: () => void;
};
export const InsuranceCard = ({ onDelete, data }: InsuranceCardProps) => {
  const onDeleteFile = () => {};
  const getFileSize = (decimals = 2) => {
    const bytes = data.fileSize ? parseInt(data.fileSize) : 0;
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };
  return (
    <div className="insurance-card">
      <div className="left-details">
        <PdfIcon />
        <div className="file-details">
          <p>
            <a href={data.insuranceCopy} target="_blank" rel="noreferrer">
              {data.fileName ? data.fileName : "Insurance Document"}
            </a>
          </p>
          <p>{getFileSize()}</p>
        </div>
      </div>
      <div className="right-action">
        <DeleteIcon onClick={onDelete} />
      </div>
    </div>
  );
};
